import React from "react";
import { FaWhatsapp } from "react-icons/fa"; // Import WhatsApp icon from react-icons

const WhatsAppButton = () => {
  const phoneNumber = "919900097989"; // Your WhatsApp number in international format
  const whatsappLink = `https://wa.me/${phoneNumber}`;

  return (
    <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
      <div className="fixed bottom-4 right-4 z-50 p-3 bg-green-500 rounded-full shadow-lg hover:bg-green-600 transition duration-300">
        <FaWhatsapp
          size={40}
          color="#25D366"
          className="cursor-pointer sm:w-10 sm:h-10"
        />
      </div>
    </a>
  );
};

export default WhatsAppButton;
